import { render, staticRenderFns } from "./viewList.vue?vue&type=template&id=5f38e132&scoped=true"
import script from "./viewList.vue?vue&type=script&lang=js"
export * from "./viewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f38e132",
  null
  
)

export default component.exports